/* eslint-disable @typescript-eslint/naming-convention */
export enum MerchantAccountStatus {
  Pending = 1,
  Active = 2,
  Inactive = 3,
}
